<template>
  <div class="NetworkDescription">
    <div class="flexWrapper">
      <div class="textWrapper">
        <div class="text" v-html="text"></div>
        <div class="cta">
          <a :href="btnHref" target="_blank" class="logoCta">
            {{btnText}}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'NetworkDescription',
    data(){
      return {

      }
    },
    components:{
    },
    props: {
      networkLogo: {
        type: String,
        default: ""
      },
      networkName: {
        type: String,
        default: ""
      },
      btnHref: {
        type: String,
        default: ""
      },
      btnText: {
        type: String,
        default: ""
      },
      text: {
        type: String,
        default: "#000"
      }
    },
    computed: {
    },
    mounted(){
      this.$el.querySelectorAll('.text a').forEach((link)=>{
        link.target = '_blank'
      })
    }
  }
</script>

<style lang="less" scoped>
  @import (reference) '~@less/_variables';
  .flexWrapper{
    display: flex;
    @media (max-width:  @bootstrap-md - 1px){
      flex-direction: column;
    }
  }
  .logoWrapper{
    margin-right: 90px;
  }

  .textWrapper{
    font-size: 1em;
    line-height: 1.4375em;
    color: #707070;
    a:link, a:visited, a:hover, a:active{
      color: @link-color;
      text-decoration: underline;
    }
    .text{
      /deep/ a{
        &:link, &:visited, &:hover, &:active{
          text-decoration: underline;
        }
      }
    }

    .cta{
      line-height: 17px;
      font-size: 14px;
      letter-spacing: 1px;
    }
  }
</style>
